<template>
    <div class="notification-sidebar">
        <div class="top">
            <div class="first">
                <SupsisButton ghost classNames="border-none" @click="goBack">
                    <i class="material-icons">chevron_left</i>
                    {{ $t("message.turnBack") }}
                </SupsisButton>
            </div>
            <div class="second">
                <div class="btnGroup">
                    <SupsisButton classNames="btnGroupItem" ghost @click="goActivities">{{
                        $t("notification.activities")
                    }}</SupsisButton>
                    <SupsisButton classNames="btnGroupItem selected" primary @click="goNotifications"
                        >{{ $t("settings.notifications") }}
                    </SupsisButton>
                </div>
            </div>
            <div class="third">
                <div>
                    <div>{{ $t("notification.dateBetween") }}</div>
                    <div class="date-calender">
                        <a-date-picker v-model="filters.startDate" :placeholder="$t('message.startDate')" />
                        <a-date-picker v-model="filters.endDate" :placeholder="$t('message.endDate')" />
                    </div>
                </div>
                <div>
                    <div>{{ $t("notification.actionType") }}</div>
                    <a-select
                        v-model="filters.activityTypes"
                        class="select-multiple"
                        mode="multiple"
                        :placeholder="$t('notification.actionType')"
                        :options="types"
                    ></a-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import _ from "lodash";
import SupsisButton from "../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "ActivitySidebar",
    components: { SupsisButton },
    props: {
        filter: {
            type: Object,
            default: () => ({
                actorIds: [],
                startDate: null,
                endDate: null,
                activityTypes: [],
            }),
        },
    },
    data: () => ({
        filters: {},
        types: [
            {
                value: "chat-assign",
                label: "When a chat is assigned to me",
            },
            {
                value: "ticket-assign",
                label: "When a ticket is assigned to me",
            },
            {
                value: "task-assign",
                label: "When a task is assigned to me",
            },
            {
                value: "chat-close-own",
                label: "When chat that I own is closed",
            },
            {
                value: "tag-actions-to-visitor",
                label: "Tags added or removed from a contact",
            },
            {
                value: "create-ticket",
                label: "Ticket is created by visitor or chatbot. Also, when a send offline message is sent from the chat wvalueget",
            },
            {
                value: "note-actions-to-visitor",
                label: "Notes added or removed from a contact",
            },
            {
                value: "visitor-profile-updates",
                label: "Visitor profile updates",
            },

            {
                value: "chat-start",
                label: "Chat is started on any platform by contact or agent",
            },
            {
                value: "user-crud",
                label: "User is created, updated or deleted",
            },
            {
                value: "department-crud",
                label: "Department is created, updated or deleted",
            },
            {
                value: "settings-crud",
                label: "Settings are created, updated or deleted",
            },
            {
                value: "integration-channel-crud",
                label: "Integration channel is created, updated or deleted",
            },
            {
                value: "login-form-crud",
                label: "Login form is updated or activated or deactivated",
            },
            {
                value: "banned-word-crud",
                label: "Banned word is created, updated or deleted",
            },
            {
                value: "email-account-crud",
                label: "Email account is created or deleted",
            },
            {
                value: "prepared-content-crud",
                label: "Prepared content is created or deleted",
            },
            {
                value: "role-crud",
                label: "Role is created, updated or deleted",
            },
            {
                value: "tag-crud",
                label: "Tag is created, updated or deleted",
            },
            {
                value: "welcome-message-crud",
                label: "Welcome message is created, updated or deleted",
            },
            {
                value: "webhook-crud",
                label: "Webhook is created, updated or deleted",
            },
            {
                value: "billing-events",
                label: "Billing events",
            },
            {
                value: "task-workflow-crud",
                label: "Task workflow is created, updated or deleted",
            },
            {
                value: "task-crud",
                label: "Task is created, updated or deleted",
            },
            {
                value: "system-status",
                label: "System online or offline status changes",
            },
            {
                value: "chatbot-story-crud",
                label: "Chatbot story is created, updated or deleted",
            },
            {
                value: "chatbot-forward-chat",
                label: "Chatbot forwards a chat to agent",
            },
            {
                value: "chatbot-user-segment-crud",
                label: "User segment is created, updated or deleted",
            },
            {
                value: "chatbot-credit-low",
                label: "When chatbot credit is low",
            },
            {
                value: "whatsapp-credit-low",
                label: "When whatsapp credit is low",
            },
            {
                value: "whatsapp-customer-group-crud",
                label: "When whatsapp customer group is created, updated or deleted",
            },
            {
                value: "whatsapp-broadcast-message-crud",
                label: "When whatsapp broadcast message is sent or completed or cancelled",
            },
            {
                value: "whatsapp-template-message-crud",
                label: "When whatsapp template message is created, updated or deleted",
            },
        ],
    }),
    methods: {
        goBack() {
            this.$router.push("/chat");
        },
        goActivities() {
            this.$router.push("/activities");
        },
        goNotifications() {
            this.$router.push("/notifications");
        },
    },
    mounted() {
        this.filters = _.cloneDeep(this.filter);
    },
    watch: {
        filter: {
            deep: true,
            handler() {
                if (!_.isEqual(this.filters, this.filter)) {
                    this.filters = this.filter;
                }
            },
        },
        filters: {
            deep: true,
            handler() {
                if (!_.isEqual(this.filters, this.filter)) {
                    this.$emit("filtered", this.filters);
                }
            },
        },
    },
});
</script>
<style lang="scss">
.notification-sidebar {
    .third {
        .date-calender {
            display: flex;
            flex-direction: column;
            gap: 5px;
            .ant-calendar-picker {
                width: 100%;
                .ant-input {
                    background-color: #f1f4f7;
                }
            }
        }
    }
    .ant-select {
        width: 100%;
        .ant-select-selection {
            background-color: #f1f4f7 !important;
            .ant-select-selection__choice {
                color: rgb(255 255 255);
                background-color: #22272d;
                border-radius: 5px;
                svg[data-icon="close"] {
                    fill: white;
                }
            }
        }
    }
}
</style>
<style scoped lang="scss">
.notification-sidebar {
    overflow-y: auto;
    height: calc(100vh - 93px);
    max-height: 100%;
    width: 275px;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-right: 1px solid var(--color-border-default);

    .border-none {
        border: none !important;
    }

    .top {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px 0;

        .first,
        .second,
        .third {
            width: 100%;
            padding: 0 20px;
        }

        .third {
            width: 100%;
            display: flex;
            gap: 10px;
            flex-direction: column;
        }

        .btnGroup {
            display: flex;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
            padding: 2px;

            .btnGrupItem {
                &.selected {
                    background: var(--color-bg-oncomponent-default);
                    box-shadow: var(--shadow-interaction-200);
                }
            }

            .supsis-button {
                border: none !important;
                font-size: 14px;
            }
        }

        .filter-groups {
            display: flex;
            flex-direction: column;

            .filter-group {
                display: flex;
                flex-direction: row;
                gap: 5px;
                align-items: center;
                padding: 16px 20px;
                cursor: pointer;

                &:not(.expanded):hover {
                    background: var(--color-bg-hover);
                    text-decoration: underline;
                }
            }

            .filters-wrapper {
                padding: 5px 16px !important;

                .filters {
                    position: relative;
                    border-radius: 4px;
                    border: 1px solid var(--color-border-default);
                    background-color: #f5f7fa;

                    .filter {
                        display: flex;
                        align-items: flex-start;
                        margin: 7px 0;

                        .filter-name {
                            flex: 1;
                            padding: 0 3px;
                            padding-top: 5px;
                        }
                    }

                    .close-icon {
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        cursor: pointer;
                    }

                    .from,
                    .to {
                        padding: 5px;
                        cursor: text;
                        margin: 20px 8px;
                        border: 1px solid var(--color-border-default);
                        border-radius: 4px;
                    }
                }
            }
        }
    }

    .bottom {
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
